import { useEffect } from "react";

const IMPERCEPTIBLE_RESIZE_TIMOUT_MS = 10;

export default function useResizeListener(callback: () => void) {
    useEffect(() => {
        let timeoutId: number | null = null;
        const resizeListener = () => {
            if (timeoutId) {
                window.clearTimeout(timeoutId);
            }
            timeoutId = window.setTimeout(callback, IMPERCEPTIBLE_RESIZE_TIMOUT_MS);
        };
        window.addEventListener("resize", resizeListener, { passive: true });
        callback();
        return () => {
            window.removeEventListener("resize", resizeListener);
        };
    });
}
